<template>
  <common :type="type"></common>
</template>
<script>
import common from './common.vue'
export default {
  name: 'Post',
  components: {
    common,
  },
  data() {
    return {
      type: '',
    }
  },
  filters: {},
  created() {
    console.log(this.router, '111111222')

    this.type = 1
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询部门列表 */
    getList() {
      this.loading = true
      pageTenant(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      console.log(postIds, 'postIdspostIds')
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '是否确认冻结此用户?',
        onOk() {
          return frozenTenant(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('冻结成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
